/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/*!**********************************!*\
  !*** ./src/performance/index.js ***!
  \**********************************/
/***/ (function(module, exports, __webpack_require__) {

	/*
	* @Author: wanchuan
	* @Date:   2017-03-23 15:29:58
	* @Last Modified by:   cdwanchuan
	* @Last Modified time: 2017-06-22 14:56:36
	*/
	
	'use strict';
	
	var _timing = __webpack_require__(/*! ./timing */ 12);
	
	var timing = _interopRequireWildcard(_timing);
	
	var _browser = __webpack_require__(/*! ./browser */ 13);
	
	var browser = _interopRequireWildcard(_browser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	//import {error} from './error';
	/**
	 * 上报Performance timing数据；
	 * eg：http://act-jshop.jd.com/plog?a=1&b=2&c=3&d=4&e=5&f=6&g=111&h=112&i=113&appName=sale&token=fe3e88sk3n&url=https://sale.jd.com/act/UGwXRYhBipTNZe7.html
	 */
	
	function setTimingRpt() {
		var appName = 'sale',
		    url = location.href;
	
		var timingTime = timing.getTimes(),
		    appcacheTime = timingTime.appcacheTime,
		    //（APP CACHE 耗时）a
		connectTime = timingTime.connectTime,
		    //（TCP 链接耗时）b
		domReadyTime = timingTime.domReadyTime,
		    //（解析 dom 树耗时）c
		initDomTreeTime = timingTime.initDomTreeTime,
		    // d
		loadEventTime = timingTime.loadEventTime,
		    //（抛出load事件）e
		loadTime = timingTime.loadTime,
		    //（总耗时）f
		lookupDomainTime = timingTime.lookupDomainTime,
		    //（DNS查询耗时（DNS寻址时间））g
		requestTime = timingTime.requestTime,
		    //（请求耗时（内容加载耗时））h
		showTime = timingTime.showTime,
		    //白屏时间（请求响应耗时） i
		domReady = timingTime.domReady; // 时间 j
	
		var url = '//act-jshop.jd.com/plog?lt=1' + '&a=' + appcacheTime + '&b=' + connectTime + '&c=' + domReadyTime + '&d=' + initDomTreeTime + '&e=' + loadEventTime + '&f=' + loadTime + '&g=' + lookupDomainTime + '&h=' + requestTime + '&i=' + showTime + '&j=' + domReady + '&l=' + browser.terminal() + '&o=' + jQuery('html').html().length + '&q=' + browser.kernel() + '&t=' + jQuery.browser.version + '&appName=' + appName + '&token=' + 'fe3e88sk3n' + '&url=' + url;
	
		var _img = new Image();
		setTimeout(function () {
			_img.src = url;
		}, 10);
	};
	
	//页面加载完成之后执行
	$(window).bind('load', function () {
		setTimeout(function () {
			setTimingRpt();
		}, 0);
	});

/***/ }),

/***/ 12:
/*!***********************************!*\
  !*** ./src/performance/timing.js ***!
  \***********************************/
/***/ (function(module, exports) {

	/*
	* @Author: wanchuan
	* @Date:   2017-03-23 15:22:02
	* @Last Modified by:   cdwanchuan
	* @Last Modified time: 2017-06-17 16:02:58
	*/
	
	'use strict';
	
	/**
	 * Outputs extended measurements using Navigation Timing API
	 * @param  Object opts Options (simple (bool) - opts out of full data view)
	 * @return Object      measurements
	 */
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var getTimes = function getTimes(opts) {
		var performance = window.performance || window.webkitPerformance || window.msPerformance || window.mozPerformance;
	
		if (performance === undefined) {
			return false;
		}
	
		var timing = performance.timing;
		var api = {};
		opts = opts || {};
	
		if (timing) {
			if (opts && !opts.simple) {
				for (var k in timing) {
					// hasOwnProperty does not work because properties are
					// added by modifying the object prototype
					if (isNumeric(timing[k])) {
						api[k] = parseFloat(timing[k]);
					}
				}
			}
	
			// Time to first paint
			if (api.firstPaint === undefined) {
				// All times are relative times to the start time within the
				// same objects
				var firstPaint = 0;
	
				// Chrome
				if (window.chrome && window.chrome.loadTimes) {
					// Convert to ms
					firstPaint = window.chrome.loadTimes().firstPaintTime * 1000;
					api.firstPaintTime = firstPaint - window.performance.timing.navigationStart;
				}
				// IE
				else if (typeof window.performance.timing.msFirstPaint === 'number') {
						firstPaint = window.performance.timing.msFirstPaint;
						api.firstPaintTime = firstPaint - window.performance.timing.navigationStart;
					}
				// Firefox
				// This will use the first times after MozAfterPaint fires
				//else if (window.performance.timing.navigationStart && typeof InstallTrigger !== 'undefined') {
				//    api.firstPaint = window.performance.timing.navigationStart;
				//    api.firstPaintTime = mozFirstPaintTime - window.performance.timing.navigationStart;
				//}
				if (opts && !opts.simple) {
					api.firstPaint = firstPaint;
				}
			}
	
			// Total time from start to load
			api.loadTime = timing.loadEventEnd - timing.fetchStart;
			// Time spent constructing the DOM tree
			api.domReadyTime = timing.domComplete - timing.domInteractive;
			// Time consumed preparing the new page
			api.readyStart = timing.fetchStart - timing.navigationStart;
			// Time spent during redirection
			api.redirectTime = timing.redirectEnd - timing.redirectStart;
			// AppCache
			api.appcacheTime = timing.domainLookupStart - timing.fetchStart;
			// Time spent unloading documents
			api.unloadEventTime = timing.unloadEventEnd - timing.unloadEventStart;
			// DNS query time
			api.lookupDomainTime = timing.domainLookupEnd - timing.domainLookupStart;
			// TCP connection time
			api.connectTime = timing.connectEnd - timing.connectStart;
			// Time spent during the request
			api.requestTime = timing.responseEnd - timing.requestStart;
			// Request to completion of the DOM loading
			api.initDomTreeTime = timing.domInteractive - timing.responseEnd;
			// Load event time
			api.loadEventTime = timing.loadEventEnd - timing.loadEventStart;
	
			api.showTime = timing.responseStart - timing.navigationStart;
	
			api.domReady = timing.domContentLoadedEventEnd - timing.navigationStart;
		}
	
		return api;
	};
	
	/**
	 * Uses console.table() to print a complete table of timing information
	 * @param  Object opts Options (simple (bool) - opts out of full data view)
	 */
	var printTable = function printTable(opts) {
		var table = {};
		var data = getTimes(opts) || {};
		Object.keys(data).sort().forEach(function (k) {
			table[k] = {
				ms: data[k],
				s: +(data[k] / 1000).toFixed(2)
			};
		});
		console.table(table);
	};
	
	/**
	 * Uses console.table() to print a summary table of timing information
	 */
	var printSimpleTable = function printSimpleTable() {
		printTable({ simple: true });
	};
	
	function isNumeric(n) {
		return !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	exports.getTimes = getTimes;
	exports.printTable = printTable;
	exports.printSimpleTable = printSimpleTable;

/***/ }),

/***/ 13:
/*!************************************!*\
  !*** ./src/performance/browser.js ***!
  \************************************/
/***/ (function(module, exports) {

	
	// mac chrome : Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.110 Safari/537.36"
	// mac firefox : Mozilla/5.0 (Macintosh; Intel Mac OS X 10.12; rv:53.0) Gecko/20100101 Firefox/53.0"
	// mac safari : Mozilla/5.0 (Macintosh; Intel Mac OS X 10_12_5) AppleWebKit/603.2.4 (KHTML, like Gecko) Version/10.1.1 Safari/603.2.4
	
	//pc safari : Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/534.57.2 (KHTML, like Gecko) Version/5.1.7 Safari/534.57.2
	//pc chrome : Mozilla/5.0 (Windows NT 6.1; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/58.0.3029.81 Safari/537.36
	//pc firefox : Mozilla/5.0 (Windows NT 6.1; WOW64; rv:53.0) Gecko/20100101 Firefox/53.0
	//pc ie : Mozilla/5.0 (Windows NT 6.1; WOW64; Trident/7.0; SLCC2; .NET CLR 2.0.50727; .NET CLR 3.5.30729; .NET CLR 3.0.30729; Media Center PC 6.0; InfoPath.3; .NET4.0C; .NET4.0E; rv:11.0) like Gecko 
	
	//iphone : Mozilla/5.0 (iPhone; CPU iPhone OS 7_1_2 like Mac OS X) AppleWebKit/537.51.2 (KHTML, like Gecko) Mobile/11D257 MicroMessenger/6.5.4 NetType/4G Language/zh_CN
	//Android :  Mozilla/5.0 (Linux; Android 6.0; MI 5 Build/MRA58K; wv) AppleWebKit/537.36 (KHTML, like Gecko) Version/4.0 Chrome/53.0.2785.49 Mobile MQQBrowser/6.2 TBS/043220 Safari/537.36 MicroMessenger/6.5.8.1060 NetType/4G Language/zh_CN
	
	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	var userAgent = navigator.userAgent;
	
	var kernel = function kernel() {
		var k;
	
		if (userAgent.indexOf('Trident') > -1) {
			//IE内核  
			k = 'ie';
		}
		if (userAgent.indexOf('Presto') > -1) {
			//opera内核 
			k = 'opera';
		}
		if (userAgent.indexOf('AppleWebKit') > -1) {
			//苹果、谷歌内核  
			if (userAgent.indexOf('Chrome') > -1 && userAgent.indexOf('Safari') > -1) {
				k = 'chrome';
			} else if (userAgent.indexOf('Safari') > -1) {
				k = 'safari';
			} else {
				k = 'other';
			}
		}
		if (userAgent.indexOf('Firefox') > -1) {
			//火狐内核  
			k = 'firefox';
		}
	
		return k;
	};
	
	var terminal = function terminal() {
		var t;
	
		if (userAgent.indexOf('Android') > -1) {
			t = 'Android';
		} else if (userAgent.indexOf('iPad') > -1) {
			t = 'iPad';
		} else if (userAgent.indexOf('iPhone') > -1) {
			t = 'iPhone';
		} else if (userAgent.indexOf('Macintosh') > -1) {
			t = 'Macintosh';
		} else {
			t = 'pc';
		}
	
		return t;
	};
	
	exports.kernel = kernel;
	exports.terminal = terminal;

/***/ })

/******/ });


// WEBPACK FOOTER //
// performance/index.js